(() => {
  if (window.RouggeCountdown) return;

  const endpointPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/;
  const resolvedEnds = new Map();
  const santiagoFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  let interval;

  function santiagoEpoch(value) {
    if (resolvedEnds.has(value)) return resolvedEnds.get(value);
    const match = endpointPattern.exec(value);
    if (!match) return NaN;
    const numbers = match.slice(1).map(Number);
    const [year, month, day, hour, minute, second] = numbers;
    const wallTime = Date.UTC(year, month - 1, day, hour, minute, second);
    const valid = new Date(wallTime);
    if (valid.getUTCFullYear() !== year || valid.getUTCMonth() + 1 !== month ||
        valid.getUTCDate() !== day || valid.getUTCHours() !== hour ||
        valid.getUTCMinutes() !== minute || valid.getUTCSeconds() !== second) return NaN;

    let result = NaN;
    for (let offset = -12; offset <= 14; offset += 1) {
      const candidate = wallTime - offset * 3600000;
      const parts = Object.fromEntries(santiagoFormatter.formatToParts(candidate).map(({ type, value: part }) => [type, part]));
      if (Number(parts.year) === year && Number(parts.month) === month &&
          Number(parts.day) === day && Number(parts.hour) === hour &&
          Number(parts.minute) === minute && Number(parts.second) === second) {
        result = candidate;
        break;
      }
    }
    resolvedEnds.set(value, result);
    return result;
  }

  function phaseAt(now, first, restart) {
    if (!Number.isFinite(first)) return { phase: 'finished', end: first };
    if (now < first) return { phase: 'first', end: first };
    if (Number.isFinite(restart) && restart > first && now < restart) {
      return { phase: 'restart', end: restart };
    }
    return { phase: 'finished', end: restart };
  }

  function update() {
    const nodes = document.querySelectorAll('[data-rougge-countdown]');
    let hasRunningTimer = false;
    const now = Date.now();

    nodes.forEach((node) => {
      const first = santiagoEpoch(node.dataset.end || '');
      const restart = santiagoEpoch(node.dataset.restartEnd || '');
      const { phase, end } = phaseAt(now, first, restart);
      const running = node.querySelector('.rougge-countdown__running');
      const finishedText = node.querySelector('.rougge-countdown__finished');
      const label = node.querySelector('.rougge-countdown__label');
      const panel = node.closest('.rougge-cyber__countdown-panel');
      if (!node.dataset.initialLabel) node.dataset.initialLabel = label.textContent;

      if (phase === 'finished') {
        running.hidden = true;
        finishedText.hidden = false;
        node.classList.add('is-finished');
        if (panel) {
          const title = panel.querySelector('.rougge-cyber__countdown-title');
          const offer = panel.querySelector('.rougge-cyber__countdown-offer');
          if (title) title.textContent = 'CYBER TERMINADO';
          if (offer) offer.textContent = '';
          finishedText.hidden = true;
        }
        return;
      }

      hasRunningTimer = true;
      running.hidden = false;
      finishedText.hidden = true;
      node.classList.remove('is-finished');
      label.textContent = phase === 'restart'
        ? (node.dataset.restartLabel || 'CYBER: 24 HORAS EXTRA')
        : node.dataset.initialLabel;

      if (panel) {
        const title = panel.querySelector('.rougge-cyber__countdown-title');
        const offer = panel.querySelector('.rougge-cyber__countdown-offer');
        if (title && offer) {
          if (!title.dataset.originalText) title.dataset.originalText = title.textContent;
          if (!offer.dataset.originalText) offer.dataset.originalText = offer.textContent;
          title.textContent = phase === 'restart' ? '24 HORAS EXTRA' : title.dataset.originalText;
          offer.textContent = phase === 'restart'
            ? '20% EXTRA CON CYBER20 · ÚLTIMA OPORTUNIDAD'
            : offer.dataset.originalText;
        }
      }

      const total = Math.ceil((end - now) / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      const two = (value) => String(value).padStart(2, '0');
      node.querySelector('[data-rougge-countdown-time]').textContent =
        two(days) + 'D : ' + two(hours) + 'H : ' + two(minutes) + 'M : ' + two(seconds) + 'S';
    });

    if (!hasRunningTimer && interval) {
      clearInterval(interval);
      interval = undefined;
    }
  }

  function start() {
    update();
    if (!interval && !document.hidden && document.querySelector('[data-rougge-countdown]:not(.is-finished)')) {
      interval = setInterval(update, 1000);
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden && interval) {
      clearInterval(interval);
      interval = undefined;
    } else if (!document.hidden) {
      start();
    }
  });
  document.addEventListener('shopify:section:load', start);
  window.RouggeCountdown = { refresh: start, phaseAt, santiagoEpoch };
  start();
})();
